import { Settings } from '@mui/icons-material';
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListSubheader,
  Popover,
  Typography
} from '@mui/material';
import React from 'react';


const TableColumnManager = ({
  allHeaders,
  selectedKeys,
  onSelectionChange,
  mandatoryKeys,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);


  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const handlePopoverClose = () => {
    setAnchorEl(null);
  };


  const handleToggle = (key) => {
    onSelectionChange((prev) =>
      prev.includes(key) ? prev.filter((c) => c !== key) : [...prev, key]
    );
  };

  const open = Boolean(anchorEl);


  return (
    <>
      <IconButton
        onClick={handlePopoverOpen}
        title="Configure Columns"
        size="small"
        disableRipple
        sx={{
          border: '1px solid',
          borderColor: 'grey.400',
          padding: '4px',
          color: '#6c757d',
        }}
      >
        <Settings fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <Box sx={{ width: 250 }}>
          <List
            sx={{ maxHeight: 300, overflow: 'auto', p: 0 }}
            subheader={
              <ListSubheader
                sx={{
                  bgcolor: 'background.paper',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                }}>
                Configure Columns
              </ListSubheader>
            }>
            {allHeaders?.map((header) => {
              const isDisabled = mandatoryKeys.includes(header.key);


              return (
                <ListItem
                  key={header.key}
                  disablePadding
                  dense
                  sx={{
                    bgcolor: isDisabled ? 'action.hover' : 'inherit',
                    '&:hover': {
                      bgcolor: isDisabled ? 'action.hover' : 'action.selected',
                    },
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }}
                  title={isDisabled ? 'Mandatory column' : ''}>
                  <FormControlLabel
                    sx={{ m: 0, width: '100%', p: '4px 8px' }}
                    onChange={() => handleToggle(header.key)}
                    control={
                      <Checkbox
                        checked={selectedKeys.includes(header.key)}
                        disabled={isDisabled}
                        size="small"
                        sx={{
                          ml: 1,
                          color: isDisabled ? 'text.disabled' : 'primary.main',
                        }}
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          color: isDisabled ? 'text.disabled' : 'text.primary',
                        }}>
                        {header.label}
                      </Typography>
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Popover>
    </>
  );
};


export default TableColumnManager;